module.exports = __webpack_public_path__ + "sgby/img/ganning-s.212f54e.png";